import * as auth from "../app/modules/Auth/_redux/authRedux";

import { all } from "redux-saga/effects";
import { combineReducers } from "redux";
import { loadingSlice } from "../custom/_redux/loadingSlice";
import { divisiSlice } from "../app/modules/hrd/_redux/divisi/divisiSlice";
import { officeSlice } from "../app/modules/hrd/_redux/office/officeSlice";
import { instalasiSlice } from "../app/modules/crm/_redux/instalasi/instalasiSlice";
import { dismantleSlice } from "../app/modules/crm/_redux/dismantle/dismantleSlice";
import { activeSlice } from "../app/modules/crm/_redux/active/activeSlice";
import { nonactiveSlice } from "../app/modules/crm/_redux/nonactive/nonactiveSlice";
import { progressSlice } from "../app/modules/crm/_redux/progress/progressSlice";
import { crmDashboardSlice } from "../app/modules/crm/_redux/dashboard/crmDashboardSlice";
import { upgradeSlice } from "../app/modules/crm/_redux/upgrade/upgradeSlice";
import { paymentSlice } from "../app/modules/crm/_redux/payment/paymentSlice";
import { jabatanSlice } from "../app/modules/hrd/_redux/jabatan/jabatanSlice";
import { karyawanSlice } from "../app/modules/hrd/_redux/karyawan/karyawanSlice";
import { kostSlice } from "../app/modules/master/_redux/kost/kostSlice";
import { mahasiswaSlice } from "../app/modules/crm/_redux/mahasiswa/mahasiswaSlice";
import { pelangganSlice } from "../app/modules/crm-corporate/_redux/pelanggan/pelangganSlice";
import { financialSlice } from "../app/modules/crm-corporate/_redux/financial/financialSlice";
import { varfinancialSlice } from "../app/modules/crm-corporate/_redux/varfinancial/varfinancialSlice";
import { quotationSlice } from "../app/modules/crm-corporate/_redux/quotation/quotationSlice";
import { poSlice } from "../app/modules/crm-corporate/_redux/po/poSlice";
import { kontrakSlice } from "../app/modules/crm-corporate/_redux/kontrak/kontrakSlice";
import { baktifasiSlice } from "../app/modules/crm-corporate/_redux/baktifasi/baktifasiSlice";
import { bformterminateSlice } from "../app/modules/crm-corporate/_redux/bformterminate/bformterminateSlice";
import { bterminateSlice } from "../app/modules/crm-corporate/_redux/bterminate/bterminateSlice";
import { paketHargaSlice } from "../app/modules/master/_redux/paket_harga/paketHargaSlice";
import { paymentTypeSlice } from "../app/modules/master/_redux/payment_type/paymentTypeSlice";
import { bankSlice } from "../app/modules/master/_redux/bank/bankSlice";
import { popSlice } from "../app/modules/master/_redux/pop/popSlice";
import { popLocationSlice } from "../app/modules/master/_redux/popLocation/popLocationSlice";
import { ponSlice } from "../app/modules/master/_redux/pon/ponSlice";
import { odpSlice } from "../app/modules/master/_redux/odp/odpSlice";
import { odpLocationSlice } from "../app/modules/master/_redux/odpLocation/odpLocationSlice";
import { portSlice } from "../app/modules/master/_redux/port/portSlice";
import { resellerSlice } from "../app/modules/master/_redux/reseller/resellerSlice";
import { targetSlice } from "../app/modules/master/_redux/target/targetSlice";
import { clustermahasiswaSlice } from "../app/modules/master/_redux/clustermahasiswa/clustermahasiswaSlice";
import { clusterresidentialSlice } from "../app/modules/master/_redux/clusterresidential/clusterresidentialSlice";
import { requestSlice } from "../app/modules/crm/_redux/request/requestSlice";
import { residentialSlice } from "../app/modules/crm/_redux/residential/residentialSlice";
import { roleSlice } from "../app/modules/user/_redux/role/roleSlice";
import { surveySlice } from "../app/modules/crm/_redux/survey/surveySlice";
import { rejectSlice } from "../app/modules/crm/_redux/reject/rejectSlice";
import { dashboardSlice } from "../app/modules/dashboard/_redux/dashboardSlice";
import { menuSlice } from "../app/modules/dashboard/_redux/menuSlice";
import { notifikasiSlice } from "../app/modules/dashboard/_redux/notifikasiSlice";
import { exportcrmSlice } from "../app/modules/crm/_redux/exportcrm/exportcrmSlice";
import { serviceSlice } from "../app/modules/radius/_redux/service/serviceSlice";
import { nasSlice } from "../app/modules/radius/_redux/nas/nasSlice";
import { memberSlice } from "../app/modules/radius/user/_redux/member/memberSlice";
import { accountSlice } from "../app/modules/radius/user/_redux/account/accountSlice";
import { announcementSlice } from "../app/modules/radius/user/_redux/announcement/announcementSlice";
import { onlineSlice } from "../app/modules/radius/user/_redux/online/onlineSlice";
import { logSlice } from "../app/modules/radius/user/_redux/log/logSlice";
import { invoiceSlice } from "../app/modules/finance/_redux/invoice/invoiceSlice";
import { faspaySlice } from "../app/modules/finance/_redux/faspay/faspaySlice";
import { recoverySlice } from "../app/modules/finance/_redux/recovery/recoverySlice";
import { retryFailedFaspaySlice } from "../app/modules/finance/_redux/retry_failed_faspay/retryFailedFaspaySlice";
import { queueFaspaySlice } from "../app/modules/finance/_redux/queue_faspay/queueFaspaySlice";
import { vendorSlice } from "../app/modules/crm-corporate/_redux/master/vendor/vendorSlice";
import { itemSlice } from "../app/modules/crm-corporate/_redux/master/item/itemSlice";
import { dismantleCategorySlice } from "../app/modules/master/_redux/dismantleCategory/dismantleCategorySlice";
import { whVendorSlice } from "../app/modules/warehouse/_redux/whVendor/vendorSlice";
import { whCatalogSlice } from "../app/modules/warehouse/_redux/whCatalog/catalogSlice";
import { whCategorySlice } from "../app/modules/warehouse/_redux/whCategory/categorySlice";
import { assetSlice } from "../app/modules/warehouse/_redux/asset/assetSlice";
import { transferSlice } from "../app/modules/warehouse/_redux/transfer/transferSlice";
import { returSlice } from "../app/modules/warehouse/_redux/retur/returSlice";
import { carrySlice } from "../app/modules/warehouse/_redux/carry/carrySlice";
import { expirationSlice } from "../app/modules/recurring/_redux/expiration/expirationSlice";
import { followupSlice } from "../app/modules/recurring/_redux/followup/followupSlice";
import { followupHistorySlice } from "../app/modules/recurring/_redux/followupHistory/followupHistorySlice";
import { waitingSlice } from "../app/modules/dismantle/_redux/waiting/waitingSlice";
import { dismantleReportSlice } from "../app/modules/dismantle/_redux/dismantleReport/dismantleReportSlice";
import { dismantleItemSlice } from "../app/modules/dismantle/_redux/dismantleItem/dismantleItemSlice";
import { localLogSlice } from "../app/modules/whatsapp/_redux/localLog/localLogSlice";
import { qontakLogSlice } from "../app/modules/whatsapp/_redux/qontakLog/qontakLogSlice";
import { ticketSlice } from "../app/modules/helpdesk/_redux/ticket/ticketSlice";
import { scheduleSlice } from "../app/modules/helpdesk/_redux/schedule/scheduleSlice";
import { workingSlice } from "../app/modules/helpdesk/_redux/working/workingSlice";
import { reportSlice } from "../app/modules/helpdesk/_redux/report/reportSlice";
import { closeSlice } from "../app/modules/helpdesk/_redux/close/closeSlice";
import { hlpcDashboardSlice } from "../app/modules/helpdesk/_redux/dashboard/hlpcDashboardSlice";
import { provinsiSlice } from "../app/modules/master/_redux/provinsi/provinsiSlice";
import { kotaSlice } from "../app/modules/master/_redux/kota/kotaSlice";
import { kecamatanSlice } from "../app/modules/master/_redux/kecamatan/kecamatanSlice";
import { kelurahanSlice } from "../app/modules/master/_redux/kelurahan/kelurahanSlice";
import { pksResidentialSlice } from "../app/modules/master/_redux/pksResidential/pksResidentialSlice";

export const rootReducer = combineReducers({
  auth: auth.reducer,
  loading: loadingSlice.reducer,
  divisi: divisiSlice.reducer,
  office: officeSlice.reducer,
  jabatan: jabatanSlice.reducer,
  karyawan: karyawanSlice.reducer,
  role: roleSlice.reducer,
  kost: kostSlice.reducer,
  paketHarga: paketHargaSlice.reducer,
  target: targetSlice.reducer,
  clustermahasiswa: clustermahasiswaSlice.reducer,
  clusterresidential: clusterresidentialSlice.reducer,
  mahasiswa: mahasiswaSlice.reducer,
  pelanggan: pelangganSlice.reducer,
  financial: financialSlice.reducer,
  varfinancial: varfinancialSlice.reducer,
  quotation: quotationSlice.reducer,
  po: poSlice.reducer,
  kontrak: kontrakSlice.reducer,
  baktifasi: baktifasiSlice.reducer,
  bformterminate: bformterminateSlice.reducer,
  bterminate: bterminateSlice.reducer,
  residential: residentialSlice.reducer,
  request: requestSlice.reducer,
  survey: surveySlice.reducer,
  reject: rejectSlice.reducer,
  instalasi: instalasiSlice.reducer,
  dismantle: dismantleSlice.reducer,
  progress: progressSlice.reducer,
  upgrade: upgradeSlice.reducer,
  payment: paymentSlice.reducer,
  dashboard: dashboardSlice.reducer,
  menu: menuSlice.reducer,
  notifikasi: notifikasiSlice.reducer,
  exportcrm: exportcrmSlice.reducer,
  service: serviceSlice.reducer,
  nas: nasSlice.reducer,
  member: memberSlice.reducer,
  account: accountSlice.reducer,
  announcement: announcementSlice.reducer,
  online: onlineSlice.reducer,
  log: logSlice.reducer,
  invoice: invoiceSlice.reducer,
  faspay: faspaySlice.reducer,
  recovery: recoverySlice.reducer,
  retryFailedFaspay: retryFailedFaspaySlice.reducer,
  queueFaspay: queueFaspaySlice.reducer,
  paymentType: paymentTypeSlice.reducer,
  bank: bankSlice.reducer,
  pop: popSlice.reducer,
  popLocation: popLocationSlice.reducer,
  pon: ponSlice.reducer,
  odp: odpSlice.reducer,
  odpLocation: odpLocationSlice.reducer,
  port: portSlice.reducer,
  reseller: resellerSlice.reducer,
  active: activeSlice.reducer,
  nonactive: nonactiveSlice.reducer,
  vendor: vendorSlice.reducer,
  item: itemSlice.reducer,
  whVendor: whVendorSlice.reducer,
  whCatalog: whCatalogSlice.reducer,
  whCategory: whCategorySlice.reducer,
  asset: assetSlice.reducer,
  transfer: transferSlice.reducer,
  retur: returSlice.reducer,
  carry: carrySlice.reducer,
  expiration: expirationSlice.reducer,
  followup: followupSlice.reducer,
  followupHistory: followupHistorySlice.reducer,
  waiting: waitingSlice.reducer,
  dismantleReport: dismantleReportSlice.reducer,
  dismantleItem: dismantleItemSlice.reducer,
  localLog: localLogSlice.reducer,
  qontakLog: qontakLogSlice.reducer,
  ticket: ticketSlice.reducer,
  schedule: scheduleSlice.reducer,
  working: workingSlice.reducer,
  report: reportSlice.reducer,
  close: closeSlice.reducer,
  dismantleCategory: dismantleCategorySlice.reducer,
  crmDashboard: crmDashboardSlice.reducer,
  hlpcDashboard: hlpcDashboardSlice.reducer,
  provinsi: provinsiSlice.reducer,
  kota: kotaSlice.reducer,
  kecamatan: kecamatanSlice.reducer,
  kelurahan: kelurahanSlice.reducer,
  pksResidential: pksResidentialSlice.reducer,
});

export function* rootSaga() {
  yield all([auth.saga()]);
}
